var m = require('mithril');
var Model = require('../../libs/Model');
var animations = require('../../libs/animations');
var formGroup = require('../../components/formGroup');
var discoveryModal = require('../discoveryModal');

var ltChannel = Object.create(Model);
  
ltChannel.name = 'Lontalk Channel';
ltChannel.url = 'lontalkchannel';
ltChannel['@class'] = 'LontalkChannel';
ltChannel.fields = {
  parent : {
    hidden: true
  },
  name: {
    default: '',
    type: 'string',
    validators: {
      presence : true, 
      length: {minimum: 3, maximum: 128, default: ''},
    }
  },
  eesPath: {
    type: 'string',
    validators: {}
  },
};

ltChannel.actions = [
  {
    name: 'Discover',
    func: function (ctrl) {
      return discoveryModal.open(ctrl.record, ctrl.init);
    }
  }
];

ltChannel.initForm();

ltChannel.view = function () { 
  return  m('form', {role:'form'}, [
    ltChannel.errorView(),
    m(formGroup, [
      m('label', {for:'name-input'}, 'Name'),
      m('input.form-control', {
        id:'name-input', 
        autocomplete: 'off',
        type:'text', 
        onchange: function(ev){ltChannel.form.name(ev.target.value)},
        value: ltChannel.form.name(),
      })
    ]),
    m(formGroup, [
      m('label', {for:'eesPath-input'}, 'EES Path'),
      m('input.form-control', {
        id:'eesPath-input', 
        autocomplete: 'off',
        type:'text', 
        onchange: function(ev){ltChannel.form.eesPath(ev.target.value)},
        value: ltChannel.form.eesPath(),
      })
    ]),
  ])
}

module.exports = ltChannel;
